import { ArrowDropDown } from '@mui/icons-material'
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { map } from 'lodash'
import styles from './ExperimentsTable.module.css'
type Order = 'asc' | 'desc'

interface EnhancedTableProps {
  headTitles: string[]
  onRequestSort: (property: string) => void
  order: Order
  orderBy: string
}

export const ExperimentsTableHead = (props: EnhancedTableProps) => {
  const { headTitles, order, orderBy, onRequestSort } = props

  return (
    <TableHead>
      <TableRow className={styles.tableRowHead}>
        {map(headTitles, headCell => (
          <TableCell
            key={headCell}
            align="left"
            padding="none"
            sortDirection={orderBy === headCell ? order : false}>
            {headCell !== '' ? (
              <TableSortLabel
                active={orderBy === headCell}
                direction={orderBy === headCell ? order : order === 'asc' ? 'desc' : 'asc'}
                onClick={() => onRequestSort(headCell)}
                IconComponent={ArrowDropDown}
                classes={{ icon: styles.sortIcon }}>
                <div className={styles.sortLabelContent}>
                  <p className={styles.tableCellHeadText}>{headCell}</p>
                </div>
              </TableSortLabel>
            ) : (
              <p className={styles.tableCellHeadText}>{headCell}</p>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
